import { render, staticRenderFns } from "./resultsDetails.vue?vue&type=template&id=8e614f40&scoped=true&"
import script from "./resultsDetails.vue?vue&type=script&lang=js&"
export * from "./resultsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e614f40",
  null
  
)

export default component.exports